module.exports = __webpack_public_path__ + "static/media/lunicaHero.f121261c.jpg";